"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _scroll_ended = _interopRequireDefault(require("./utils/scroll_ended"));

require("../css/list.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var List = function List(_ref) {
  var children = _ref.children,
      onScrollEnd = _ref.onScrollEnd,
      scrollEndOffset = _ref.scrollEndOffset,
      spaceBetweenItems = _ref.spaceBetweenItems,
      style = _ref.style;

  var _onScroll = function onScroll(event) {
    if (onScrollEnd && (0, _scroll_ended.default)(event.target, scrollEndOffset)) {
      onScrollEnd();
    }
  };

  return _react.default.createElement("div", {
    className: "vn-list",
    onScroll: function onScroll(e) {
      return _onScroll(e);
    },
    style: style
  }, _react.default.Children.map(children, function (child, index) {
    var space = children.length - 1 === index ? 0 : spaceBetweenItems;
    return _react.default.createElement("div", {
      style: {
        paddingBottom: "".concat(space, "px")
      }
    }, child);
  }));
};

List.propTypes = {
  children: _propTypes.default.node,
  onScrollEnd: _propTypes.default.func,
  scrollEndOffset: _propTypes.default.number,
  spaceBetweenItems: _propTypes.default.number,
  style: _propTypes.default.shape({})
};
List.defaultProps = {
  children: undefined,
  onScrollEnd: undefined,
  scrollEndOffset: 0,
  spaceBetweenItems: 0,
  style: undefined
};
List.displayName = 'List';
var _default = List;
exports.default = _default;